import { useEffect, useState } from 'react';

// Tailwind's `sm` boundary, expressed once. Keep in step with every `max-sm:` class.
export const COMPACT_MEDIA_QUERY = '(max-width: 639.98px)';

// A viewport query, never a user-agent string. Used only where the small-viewport rendering
// changes WHICH fields exist (the entry stepper); everything else is a `max-sm:` class.
export function useIsCompactViewport(): boolean {
  const [compact, setCompact] = useState(
    () => typeof window !== 'undefined' && window.matchMedia(COMPACT_MEDIA_QUERY).matches
  );

  useEffect(() => {
    const query = window.matchMedia(COMPACT_MEDIA_QUERY);
    const onChange = (event: MediaQueryListEvent) => setCompact(event.matches);
    setCompact(query.matches);
    query.addEventListener('change', onChange);
    return () => query.removeEventListener('change', onChange);
  }, []);

  return compact;
}
